export const selectLastName = state =>
  state.persistedSignupData.last_name || '';
